import { ACC_TYPES, IPHONE_MODELS, WATTS, accTypeOf, usesModels } from "@/lib/store";

const chip = (active) =>
  `shrink-0 rounded-full border px-4 py-2 text-sm font-medium transition-colors duration-300 ${active ? "border-white bg-white text-black" : "border-white/15 text-zinc-200 hover:border-white/40 hover:text-white"}`;

export const matchesAcc = (p, f) => {
  const t = accTypeOf(p);
  if (f.type !== "todos" && t !== f.type) return false;
  if (f.model && !(p?.compatible || []).includes(f.model)) return false;
  if (f.watt && p?.wattage !== f.watt) return false;
  return true;
};

export const HPrimeFilters = ({ items, value, onChange }) => {
  const ofType = items.filter((p) => accTypeOf(p) === value.type);
  const models = IPHONE_MODELS.filter((m) => ofType.some((p) => (p?.compatible || []).includes(m)));
  const watts = WATTS.filter((w) => ofType.some((p) => p?.wattage === w));
  const count = (id) => items.filter((p) => accTypeOf(p) === id).length;

  return (
    <div data-testid="hprime-filters" className="mt-4 space-y-3">
      <div className="no-scrollbar -mx-5 flex gap-2 overflow-x-auto px-5 sm:mx-0 sm:flex-wrap sm:px-0">
        {[{ id: "todos", label: "Todos" }, ...ACC_TYPES].map((t) => (
          <button key={t.id} data-testid={`hprime-type-${t.id}`} onClick={() => onChange({ type: t.id, model: "", watt: "" })} className={chip(value.type === t.id)}>
            {t.label}{t.id !== "todos" && <span className="mono ml-2 text-[11px] opacity-70">{count(t.id)}</span>}
          </button>
        ))}
      </div>
      {usesModels(value.type) && (
        <label className="flex w-full items-center gap-3 sm:w-fit">
          <span className="shrink-0 text-sm text-zinc-300">Modelo do seu iPhone:</span>
          <select data-testid="hprime-model-select" value={value.model} onChange={(e) => onChange({ ...value, model: e.target.value })}
            className="w-full rounded-full border border-white/15 bg-transparent px-4 py-2.5 text-sm text-white outline-none focus:border-white/40 sm:w-64">
            <option value="" className="bg-zinc-900">Todos os modelos</option>
            {models.map((m) => <option key={m} value={m} className="bg-zinc-900">{m}</option>)}
          </select>
        </label>
      )}
      {value.type === "fonte" && watts.length > 0 && (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm text-zinc-300">Potência:</span>
          {["", ...watts].map((w) => (
            <button key={w || "all"} data-testid={`hprime-watt-${w || "todas"}`} onClick={() => onChange({ ...value, watt: w })} className={chip(value.watt === w)}>{w || "Todas"}</button>
          ))}
        </div>
      )}
    </div>
  );
};
